import { useMemo } from 'react';
import Restriction from '../../../Restriction/Restriction.js';
import { getPrecision } from '../../../Utils/numeriHelper.js';
import { getValueFormat, InputFormatsEnum } from '../shared.js';

function isNumberFormat(format) {
    return format === InputFormatsEnum.currency || format === InputFormatsEnum.number;
}
function isKeyPressed(event) {
    return event.key && event.key.length === 1;
}
function useRestrictions(restrictions, format, precision, onKeyDown) {
    const handleKeyPress = useMemo(() => {
        let compRestrictions = restrictions;
        if (isNumberFormat(format)) {
            const numberRestriction = getPrecision(getValueFormat(format), precision) === 0
                ? Restriction.DefaultValues.numerinegativi
                : Restriction.DefaultValues.numeridecimalinegativi;
            compRestrictions = [numberRestriction, ...(restrictions || [])];
        }
        return (event) => {
            if (isKeyPressed(event)) {
                if (compRestrictions && compRestrictions.length > 0) {
                    if (!Restriction.isValid(event, compRestrictions)) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }
            }
            onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        };
    }, [format, onKeyDown, precision, restrictions]);
    return handleKeyPress;
}

export { useRestrictions as default };
